/* eslint-disable max-lines-per-function */
import { Injectable } from '@angular/core';
import { ValidationErrors, ValidatorFn } from '@angular/forms';

import { AutomationConditionType } from '@core/workflow-automations-types';
import {
  AutomationConditionErrorsType,
  AutomationConditionForm,
} from '@recruitee/workflow-automations-types';

@Injectable()
export class AutomationConditionsValidationService {
  public conditionValidator(): ValidatorFn {
    return (control: AutomationConditionForm): ValidationErrors | null => {
      const conditionFormValue = control.getRawValue();

      switch (conditionFormValue.type) {
        case AutomationConditionType.CandidateEventOrganizer:
          const organizer = conditionFormValue.data?.admin_id;
          if (!organizer) {
            return { [AutomationConditionErrorsType.EmptyOrganizer]: true };
          }
          break;
        case AutomationConditionType.CandidatePreferredLocation:
          const preferredLocation = conditionFormValue.data?.location_id;
          if (!preferredLocation) {
            return { [AutomationConditionErrorsType.EmptyPreferredLocation]: true };
          }
          break;
        case AutomationConditionType.CandidateTags:
          const tags = <string[]>conditionFormValue.data?.tags;
          if (!tags?.length) {
            return { [AutomationConditionErrorsType.EmptyTags]: true };
          }
          break;
        case AutomationConditionType.CandidateEventInterviewersInclude:
          const interviewers = <string[]>conditionFormValue.data?.interviewer_ids;
          if (!interviewers?.length) {
            return { [AutomationConditionErrorsType.EmptyInterviewers]: true };
          }
          break;
        case AutomationConditionType.CandidateTaskAssigneesInclude:
          const assignees = <string[]>conditionFormValue.data?.admin_ids;
          if (!assignees?.length) {
            return { [AutomationConditionErrorsType.EmptyAssignees]: true };
          }
          break;
        case AutomationConditionType.CandidateSourceTags:
          const sourceTag = conditionFormValue.data?.source_tag;
          if (!sourceTag) {
            return { [AutomationConditionErrorsType.EmptySourceTags]: true };
          }
          break;
        case AutomationConditionType.CandidateOrigin:
          const source = conditionFormValue.data?.source;
          if (!source) {
            return { [AutomationConditionErrorsType.EmptyOrigin]: true };
          }
          break;
        case AutomationConditionType.CandidateMovedFromStage:
          const fromStage = conditionFormValue.data?.stage_id;
          if (!fromStage) {
            return { [AutomationConditionErrorsType.EmptyFromStage]: true };
          }
          break;
        case AutomationConditionType.JobLocation:
          const locationIds = <string[]>conditionFormValue.data?.location_ids;
          if (!locationIds?.length) {
            return { [AutomationConditionErrorsType.EmptyLocation]: true };
          }
          break;
        case AutomationConditionType.JobDepartment:
          const department = conditionFormValue.data?.department_id;
          if (!department) {
            return { [AutomationConditionErrorsType.EmptyDepartment]: true };
          }
          break;
        case AutomationConditionType.JobRecruiter:
          const recruiter = conditionFormValue.data?.admin_id;
          if (!recruiter) {
            return { [AutomationConditionErrorsType.EmptyRecruiter]: true };
          }
          break;
        case AutomationConditionType.JobHiringManager:
          const hiringManager = conditionFormValue.data?.admin_id;
          if (!hiringManager) {
            return { [AutomationConditionErrorsType.EmptyHiringManager]: true };
          }
          break;
        case AutomationConditionType.JobWorkModel:
          const workModels = <string[]>conditionFormValue.data?.work_models;
          if (!workModels?.length) {
            return { [AutomationConditionErrorsType.EmptyWorkModel]: true };
          }
          break;
        case AutomationConditionType.JobCreator:
          const creator = conditionFormValue.data?.admin_id;
          if (!creator) {
            return { [AutomationConditionErrorsType.EmptyCreator]: true };
          }
          break;
        case AutomationConditionType.JobPreviousStatus:
          const previousStatus = conditionFormValue.data?.status;
          if (!previousStatus) {
            return { [AutomationConditionErrorsType.EmptyPreviousStatus]: true };
          }
          break;
        default:
          const conditionType = conditionFormValue.type;
          if (!conditionType) {
            return { [AutomationConditionErrorsType.EmptyCondition]: true };
          }
          break;
      }

      return null;
    };
  }
}
